<template>
  <div class="Kaiji">
    <div class="form1">
        <el-form :inline="true" :rules="rules" :model="开机情报" ref="开机情报"> 
            <el-form-item class="as_btn">
              <el-button type="primary" @click="发送开机指令()" :disabled="btnFlag">发送开机指令</el-button>
            </el-form-item>

            <el-form-item prop="macStr" label="目标MAC地址">
                <el-input v-model="开机情报.macStr"></el-input>
            </el-form-item>
            <el-form-item prop="broadcastAddr" label="广播地址">
                <el-input v-model="开机情报.broadcastAddr"></el-input>
            </el-form-item>
            <el-form-item prop="port" label="端口">
                <el-input v-model="开机情报.port"></el-input>
            </el-form-item>
        </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Kaiji',
  data(){
    return {
      开机情报:{
        macStr: '',
        broadcastAddr: '255.255.255.255',
        port: '9'
      },
      rules: {
        macStr: [
            { required: true, message: '不能为空', trigger: 'blur' },
            // : 或 - 分割的mac地址
            {
              pattern: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/,
              message: 'MAC地址格式错误，请使用标准格式：如 00:1A:2B:3C:4D:5E 或 00-1A-2B-3C-4D-5E',
              trigger: 'blur'
            }
        ],
        broadcastAddr: [
            // ipv4地址
            { 
              pattern: /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
              message: '广播地址格式错误，请输入合法的IPv4地址（如：255.255.255.255）', 
              trigger: 'blur' 
            }
        ],
        port: [
            //数字 
            { 
              pattern: /[0-9]+$/, 
              message: '端口号必须为纯数字', 
              trigger: 'blur' 
            },
            {
              validator: (rule, value, callback) => {
                const port = parseInt(value, 10);
                if (port >= 0 && port <= 65535) {
                  callback();
                } else {
                  callback(new Error('端口号必须在0-65535之间'));
                }
              },
              trigger: 'blur'
            }
        ],
      },
      btnFlag: false
    };
  },
  props: {
    msg: String
  },
  methods:{
    发送开机指令(){
      let _this = this;
      this.btnFlag = true;
      this.$refs.开机情报.validate((valid) => {
        if (valid) {
          this.$axios.post('/ssBaseS3Controller/Wake_on_LAN.do',{...this.开机情报,})
            .then(res => {
              _this.$message({message: '开机成功', type: 'success', showClose: true, duration: 1000 });
              _this.showAll()
          }).catch(err => { 
            _this.btnFlag = false;
            _this.$message({ message: '开机不成功', type: 'error', showClose: true, duration: 1000});
            console.error(err); 
          })
        } else {
            _this.btnFlag = false;
            console.error('error submit!!');
            _this.$message({ message: '情报有误', type: 'error', showClose: true, duration: 1000});
        }
      });
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
